import React from 'react'
import Cards from './components/Card'
import MDBox from 'components/MDBox'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
function AdminReports() {
  return (
   <DashboardLayout>
    <DashboardNavbar/>
    <Cards/>
   </DashboardLayout>
  )
}

export default AdminReports
